var _circle, _path, _rect, _rect2, _path2, _rect3, _path3, _path4, _line, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAspiringMemberIllu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 272,
    viewBox: "0 0 305 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 126.5,
    r: 126.5,
    fill: "#E1E1E4",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226 194.5C226 204.711 230.162 214.503 237.569 221.724C244.977 228.944 255.024 233 265.5 233C275.976 233 286.023 228.944 293.431 221.724C300.838 214.503 305 204.711 305 194.5L265.5 194.5L226 194.5Z",
    fill: "#91CED2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.7803,
    y: 139,
    width: 45,
    height: 45,
    fill: "#2D3E91"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 150,
    width: 45,
    height: 45,
    fill: "#FFD1CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 223C46.1727 223 51.1335 220.946 54.7911 217.289C58.4488 213.632 60.5036 208.672 60.5036 203.5C60.5036 198.328 58.4488 193.368 54.7911 189.711C51.1335 186.054 46.1727 184 41 184L41 203.5L41 223Z",
    fill: "#91CED2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 184,
    width: 39,
    height: 39,
    fill: "#FFF3EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165 75L223.89 171.75H106.11L165 75Z",
    fill: "#2D3E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165 125L142.5 112L165 75L188 113L165 125Z",
    fill: "#BCC5EF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 181.5,
    y1: 94,
    x2: 181.5,
    y2: 142.483,
    stroke: "#F86969",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 94,
    width: 38,
    height: 24.8965,
    fill: "#F86969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspiringMemberIllu);
export default __webpack_public_path__ + "static/media/aspiring-member-illu.62ee8e220bd3b5dd84b2909fd3fa71d5.svg";
export { ForwardRef as ReactComponent };